angular.module('Itao.IndicatorMap').factory('IndicatorService', function (mapConfig, UtilityService) {
  'use strict';

  /**
   *
   * @param uid
   * @param name
   * @param key
   * @param unit
   * @param category
   * @param type
   * @param list
   * @param isDefault
   * @param defaultScale
   * @param defaultColorSet
   * @param indication
   * @param hint
   * @param source
   * @param statement
   * @param calculation
   * @param defaultInvert
   * @param classidentifier
   * @param sorting
   * @param categorical
   * @param listIndex
   * @param prefix
   * @param redLines
   * @constructor
   */
  function Indicator(uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines) {
    this.uid = uid;
    this.name = name;
    this.key = key;
    this.unit = unit;
    this.category = category;
    this.type = type;
    this.list = list;
    this.isDefault = isDefault;
    this.defaultScale = defaultScale;
    this.defaultColorSet = defaultColorSet;
    this.indication = indication;
    this.hint = hint;
    this.source = source;
    this.statement = statement;
    this.calculation = calculation;
    this.defaultInvert = defaultInvert;
    this.inverted = false;
    this.class = classidentifier;
    this.sorting = sorting;
    this.listIndex = listIndex;
    this.categorical = categorical;
    this.prefix = prefix != null ? prefix : '';
    this.redLines = redLines ? redLines.split(";") : '';
  }

  Indicator.prototype.invertScale = function () {
    this.reverseColors();
    this.reversePointColors();
    this.inverted = !this.inverted;
  };

  Indicator.prototype.reverseColors = function() {
    if(!this.scales) return;
    var invertedColors = [];
    this.scales.forEach(function (scale, index) {
      invertedColors.push(scale.color);
    });
    invertedColors.reverse();
    this.scales.forEach(function (scale, index) {
      scale.color = invertedColors[index];
    });
  };

  Indicator.prototype.reversePointColors = function() {
    if(!this.pointScales) return;
    var invertedColors = [];
    this.pointScales.forEach(function (scale, index) {
      invertedColors.push(scale.color);
    });
    invertedColors.reverse();
    this.pointScales.forEach(function (scale, index) {
      scale.color = invertedColors[index];
    });
  };

  /**
   *
   * @param dataLayer
   * @param selectedIndicator
   * @param colorSet
   * @param method
   * @param numberOfScales
   */
  Indicator.prototype.updateScales = function(dataLayer, selectedIndicator, colorSet, method, numberOfScales) {
    this.scales = UtilityService.buildIndicatorScales(dataLayer, this, colorSet, method, numberOfScales);
    if(this.defaultInvert) {
      this.reverseColors();
    }
  };

  /**
   * @param dataLayer
   * @param selectedIndicator
   * @param colorSet
   * @param method
   * @param numberOfScales
   */
  Indicator.prototype.updatePointScales = function(dataLayer, selectedIndicator, colorSet, method, numberOfScales) {
    if(!dataLayer) return;
    this.pointScales = UtilityService.buildIndicatorScales(dataLayer, this, colorSet, method, numberOfScales);
    if(this.defaultInvert) {
      this.reversePointColors();
    }
  };

  /**
   * Returns the Color for a given value
   * or the configured value from the notAvailable Styling options
   * if the value does not match any range in the scale
   * @param {float} value
   * @returns {string}
   */
  Indicator.prototype.getColorForValue = function (value) {
    if(value === null) return mapConfig.styling.default.fillColor;
    return this.scales.reduce(function (memory, scale) {
      if (scale.isValueInsideScale(value)) {
        return scale.color;
      }
      return memory;
    }, mapConfig.styling.default.fillColor);
  };

  /**
   * Returns the Color for a given value
   * or the configured value from the notAvailable Styling options
   * if the value does not match any range in the scale
   * @param {float} value
   * @returns {string}
   */
  Indicator.prototype.getPointColorForValue = function (value) {
    if(value === null) return mapConfig.styling.default.fillColor;
    return this.pointScales.reduce(function (memory, scale) {
      if (scale.isValueInsideScale(value)) {
        return scale.color;
      }
      return memory;
    }, mapConfig.styling.default.fillColor);
  };

  /**
   *
   * @param indicators
   * @param uids
   * @returns {{}}
   */
  function filterIndicatorsByUids(indicators, uids) {
    var filteredIndicators = {},
        allUids = uids;
    allUids.forEach(function(uid) {
      if(indicators && indicators.hasOwnProperty(uid) && indicators[uid] != null) {
        if(uids.indexOf(uid) > -1) indicators[uid].hasShapeData = true;
        filteredIndicators[uid] = indicators[uid];
      } else {
        //console.warn('Indicator ' + uid + ' is referenced, but not found in indicators. This probably means that an indicatorData references an indicator that is not loaded.');
      }
    });
    return filteredIndicators;
  }

  /**
   *
   * @param indicators
   * @returns {{}}
   */
  function filterOutSetIndicators(indicators) {
    if(!indicators) return {};
    var filteredIndicators = {};
    angular.forEach(indicators, function(indicator, uid) {
      if((!indicator.list && !indicator.type) || indicator.isDefault) {
        filteredIndicators[uid] = indicator;
      }
    });
    return filteredIndicators;
  }

  /**
   *
   * @param indicators
   * @param indicatorSets
   * @returns Array
   */
  function findIndicatorSetsInIndicators(indicators, indicatorSets) {
    if(!indicators) return [];
    var filteredIndicatorSets = [];
    angular.forEach(indicators, function(indicator) {
      if(indicator.isDefault) {
        filteredIndicatorSets.push(indicatorSets.filter(function(type) {
          return type.uid == indicator.type;
        })[0]);
      }
    });
    return filteredIndicatorSets.sort(function(a,b) {
      return a.sorting - b.sorting;
    });
  }

  return {
    createIndicator: function (uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines) {
      return new Indicator(uid, name, key, unit, category, type, list, isDefault, defaultScale, defaultColorSet, indication, hint, source, statement, calculation, defaultInvert, classidentifier, sorting, categorical, listIndex, prefix, redLines);
    },
    filterIndicatorsByUids: filterIndicatorsByUids,
    filterOutSetIndicators: filterOutSetIndicators,
    findIndicatorSetsInIndicators: findIndicatorSetsInIndicators
  };
});
